import { useState, useRef, FC } from "react";

import useOnClickOutside from "@/hooks/useOnClickOutside";
import FilterButton from "@/components/FilterDropdown/FilterButton";
import ProductsFilterBox from "./ProductsFilterBox";

interface Props {
  filter: {
    rating?: number;
    minPrice?: number;
    maxPrice?: number;
    minDiscount?: number;
    minReviews?: number;
    maxReviews?: number;
    isPrime?: boolean;
    isBestSeller?: boolean;
    isChoice?: boolean;
  };
  setFilter: React.Dispatch<
    React.SetStateAction<{
      rating?: number;
      minPrice?: number;
      maxPrice?: number;
      minDiscount?: number;
      minReviews?: number;
      maxReviews?: number;
      isPrime?: boolean;
      isBestSeller?: boolean;
      isChoice?: boolean;
    }>
  >;
}

const ProductsFilter: FC<Props> = ({ filter, setFilter }) => {
  const [showFilter, setShowFilter] = useState(false);

  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setShowFilter(false));

  return (
    <div ref={ref}>
      <FilterButton
        onClick={() => {
          setShowFilter(!showFilter);
        }}
        isActive={!!showFilter}
        filterApplied={true}
      ></FilterButton>
      {showFilter && (
        <ProductsFilterBox
          filter={filter}
          setFilter={setFilter}
          closeFilter={() => setShowFilter(false)}
        />
      )}
    </div>
  );
};

export default ProductsFilter;
